







import { Component, Vue } from 'vue-property-decorator'
import sliceError from '@/assets/img/SliceError.png'

@Component({
})
export default class SliceNotSupported extends Vue {
  sliceError = sliceError
  sliceErrorText = 'Insufficient data for calculations.'
}
